import { Layout } from 'components/Layout/Layout';
import CMSPage from 'components/PageWrapper/PageWrapper';
import withApollo from 'lib/apollo';
import * as React from 'react';
import { PublicCMSLayout } from '../components/Layout/PublicCMSLayout';

function TermsOfUsePage() {
  return (
    <Layout classNames={['h-background--navy-200']} title="Terms of Use">
      <PublicCMSLayout>
        <CMSPage title="Terms of Use" pageUrl="terms-of-use" />
      </PublicCMSLayout>
    </Layout>
  );
}

export default withApollo(TermsOfUsePage, { useTemporaryToken: true });
